import type { ISiteSettings } from '@sravni/types/lib/sitesettings';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

type IState = ISiteSettings;

const initialState: IState = {
  header: {
    menu: undefined,
    mobileMenu: undefined,
  },
  footer: {
    menu: undefined,
    socialLinks: undefined,
    support: undefined,
  },
};

const siteSettingsSlice = createSlice({
  name: 'siteSettings',
  initialState,
  reducers: {
    setSettings: (_, action: PayloadAction<ISiteSettings>) => action.payload,
  },
});

const { actions, reducer } = siteSettingsSlice;

export const { setSettings } = actions;

export default reducer;
